import axios from 'axios';
import moment from 'moment-timezone';

export default class Helper {

    /**
     * Windows resize listener
     */
    static windowresize(store) {
        const callback =  () => {
            const params = {
                width : window.innerWidth,
                height: window.innerHeight
            }
            store.commit('udpatewindowsize', params)
          }
          
        window.onresize = callback;
    }

    /**
     * This will check if number is odd or even
     * @param {*} number 
     * @param {*} type 
     * @returns {Boolean}
     */
    static checkOddEven(number, type = 'odd') {

        if(type == 'odd') {
            return number % 2 == 0;
        } else {
            return Math.abs(number % 2) == 1;
        }
    }

     /**
     * Get user timezone
     * 
     */
      static usertimezone() {
        return moment.tz.guess()
    }

     /**
     * Check if US timezone
     */
      
     static isUStimezone() {
        return this.usertimezone().match(/America/i) ? true : false
     }

 
    /**
     * Return date string display
     * ref : https://momentjs.com/docs/#/displaying/calendar-time/
     * America/Boise
     * Asia/Manila
     */
    static datestring(date) {
        console.log('this.usertimezone()', this.usertimezone().match(/America/i))
        const isUStimezone = this.isUStimezone()
        const format       = 'MM/DD/YYYY'
        const parsingdate  = date
        const currentdate  = isUStimezone ? moment().format(format) :  moment().tz('America/Boise').format(format)
        const diff         = moment(parsingdate).diff(currentdate, 'days')
        
        let rel = date


        switch (diff) {
            case -1:
                rel = 'Yesterday'
                break;

            case 0:
                rel = 'Today'
                break;

            case 1:
                rel = 'Tomorrow'
                break;

        
            default:

                break;
        }

        return  rel
    }
    
    /**
     * Format date with Mountain Standard Time
     * @param {String} date 
     * @param {String} format 
     */
    static formatdate(date, format, force = false) {
        const isUStimezone = force ? false : this.isUStimezone()
        const newdate      = force ? moment(date).utc() : moment(date).utc().format('MM/DD/YYYY hh:mm:ss A')
        // console.log(date, force, 'isUStimezone', isUStimezone)

        return isUStimezone  ? moment(newdate).utc().format(format) : moment(newdate).utc().tz('America/Boise').format(format)
    }
    

    /**
     * Axios global configuration
     */
    static axoisglobalconfig() {
        /**
         * Set default base url
         */
        axios.defaults.baseURL = process.env.VUE_APP_APIROOT;

        /**
         * Set authorization token
         * @param {String} token
         */

        const token = this.getCookie('holeswebtoken');
        if(token) {
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }
    }

    /**
     * Adding Cookie
     * @param {String} cname cookies name
     * @param {String} cvalue cookies value
     * @param {Number} exdays expriation number of days
     */
    static  setCookie(cname, cvalue, exdays = 1) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays*24*60*60*1000));
        let expires = "expires="+ d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }

    /**
     * Getting a cookie
     * @param {String} cname cookie name
     * @returns {String} cookie data
     */
    static getCookie(cname) {
        let name = cname + "=";
        let decodedCookie = decodeURIComponent(document.cookie);
        let ca = decodedCookie.split(';');

        for(let i = 0; i <ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
    }

    /**
     * Delete all cookies
     */
    static deleteAllCookies() {
        var cookies = document.cookie.split(";");
    
        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }

    /**
     * Deleting specific cookie
     * @param {String} cname cookie name 
     */
    static deleteCookie(cname) {
        document.cookie = `${cname}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
    }

    /**
     * Check if has session or expired session
     * @returns promise
     */
    static checksession() {
        const session = new Promise((resolve, reject) => {
             axios.get('/profile')
                .then(res => {
                    resolve(res.data);
                })
                .catch((err) => {
                    reject(err);
                })
        });

        return session;
    }

    /**
     * Serialize Function
     * Used in JSON Stringify
     * @param {*} key
     * @param {Function} value 
     * @returns string
     */
    static serialize(key, value) {
		if (typeof value === 'function') {
			return value.toString();
		}
		return value;
	}
    
	/**
     * Deserialize Function
     * @param {*} key 
     * @param {function} value 
     * @returns function
     */
	static deserialize(key, value) {
		if (value && typeof value === "string" && value.substr(0, 8) == "function") {
			var startBody = value.indexOf('{') + 1;
			var endBody   = value.lastIndexOf('}');
			var startArgs = value.indexOf('(') + 1;
			var endArgs = value.indexOf(')');
	
			return new Function(value.substring(startArgs, endArgs), value.substring(startBody, endBody));
		}
		return value;
	} 
    
}